import produce from 'immer'
import lodash from 'lodash'
import { values } from 'lodash'
import React, { ReactElement, useEffect } from 'react'

import { useField } from '../../../../../1stlog-ui/src/components/Field'
import { getNotificationTriggerLabels } from '../../../../../1stlog-ui/src/constants/notificationTriggers'
import {
  useLocalStorage,
  usePrevious,
} from '../../../../../1stlog-ui/src/hooks'
import { useProductSettings } from '../../Products'
import { mergeNotificationOptions } from './utils'

const ClientNotificationsHandler = (): ReactElement => {
  const product = undefined

  const { notificationOptions, settingsId } = useProductSettings()

  // local storage  as { [productId]: [...clientNotifications]}
  const [localClientNotifications, setLocalClientNotifications] =
    useLocalStorage('clientNotifications', {})

  // clientNotifications array as field state
  const [clientNotifications, setClientNotifications] = useField(
    'clientNotifications',
    {
      asState: true,
    },
  )

  // set new notification option list and load saved values
  const previousSettingsId = usePrevious(settingsId)
  useEffect(() => {
    if (previousSettingsId !== settingsId) {
      // merge duplicate options that just differ in type
      let options = values(mergeNotificationOptions(notificationOptions ?? []))

      // filter out unknown notification types
      const notificationTriggerLabels = getNotificationTriggerLabels()
      options = lodash.filter(options, (o) =>
        lodash.keys(notificationTriggerLabels).includes(o.trigger),
      )

      const localSettings = lodash.get(localClientNotifications, settingsId)
      options = lodash.map(options, (option) => {
        const { trigger, types } = option
        const localOption = lodash.find(
          localSettings,
          (s) => s.trigger === trigger,
        )
        if (!localOption) {
          return option
        }
        const newOption = { ...localOption, ...option }
        lodash.forEach(types, (type) => {
          lodash.set(newOption, type, lodash.get(localOption, type))
        })
        return newOption
      })
      setTimeout(() => setClientNotifications(lodash.values(options)), 0)
    }
  }, [settingsId])

  // save all changes to local storage
  useEffect(() => {
    setLocalClientNotifications(
      produce((s) => lodash.set(s, settingsId, clientNotifications)),
    )
  }, [clientNotifications])

  return <></>
}

export default ClientNotificationsHandler
